namespace appn.views.tasks.index {

    class InitArgs {
        modelHasTemplates: boolean = false;
        systemStatusesList: Array<SelectListItem> = [];
        timeZonesList: Array<SelectListItem> = [];
        userGroupsList: Array<SelectListItem> = [];
        usersList: Array<AppnSelectListItem> = [];
        dateFilter: string = emptyString;
        tasksCreate: string = emptyString;
        tasksAjaxGetMergedStatuses: string = emptyString;
        tasksIndex: string = emptyString;
        templateId: string = emptyString;
        parentTaskId: string = emptyString;
        locationFilter: string = emptyString;
        statusFilter: string = emptyString;
        isParameterized: boolean = false;
    }

    const _taskTemplateStatusesCache = {} as Dictionary<Array<TaskStatusObj>>;

    let _systemStatuses: JQuery<HTMLElement>;
    let _initArgs: InitArgs;
    let _dataTable: any;
    let _selectedItems: any;
    let _isFirstLoad: boolean = true;

    export function init(args: InitArgs): void {
        _initArgs = args;
        addEvents();
        appn.dateFilter.init(_initArgs.dateFilter);
        appn.taskTemplateFilter.init();

        // Assign filter values and update the cache on initial page load when redirected from map to index
        if (_isFirstLoad && _initArgs.isParameterized) {
            $('#sCustom_0').val(_initArgs.statusFilter);
            saveMeState.createOrUpdateRegister({ elementId: 'sCustom_0', value: _initArgs.statusFilter });

            let user = _initArgs.usersList.find(u => u.selected === true);
            if (user?.value) {
                $('#sCustom_2').val(user.value);
                saveMeState.createOrUpdateRegister({ elementId: 'sCustom_2', value: user.value });
            }

            let userGroup = _initArgs.userGroupsList.find(ug => ug.selected === true);
            if (userGroup?.value) {
                $('#sCustom_4').val(userGroup.value);
                saveMeState.createOrUpdateRegister({ elementId: 'sCustom_4', value: userGroup.value });
            }

            $('#LocationFilter').val(_initArgs.locationFilter);
            saveMeState.createOrUpdateRegister({ elementId: 'LocationFilter', value: _initArgs.locationFilter });
            saveMeState.createOrUpdateRegister({ elementId: 'appnTaskTemplateFilter', value: _initArgs.templateId });
            saveMeState.createOrUpdateRegister({ elementId: 'appnDateFilter', value: _initArgs.dateFilter });
        }
        createDataTable();
    }

    function addEvents() {
        $('#manageBtn').on('click', function(e: Event) {
            appn.dialog.showLoading();
        });

        $('#importBtn').on('click', function(e: Event) {
            appn.dialog.showLoading();
        });

        $('#clearParentTask').on('click', function(e: Event) {
            appn.location.navTo(_initArgs.tasksIndex);
        });

        if ($('#ParentTaskId').val() !== undefined)
            $(document).on('click', '.btn-resetFilters', function(e: Event) {
                appn.location.navTo(_initArgs.tasksIndex);
            });
    }

    function createDataTable() {
        _dataTable = appn.dataTable.create('.dataTable', {
            sDom: appn.dataTable.genSDom(1, 0, 6),
            scrollX: '100%',
            sAjaxSource: 'Tasks/DataTable',
            fnServerData: function (data: any) {
                data.push(appn.dataTable.getStateOrDefault('sCustom_0', $('#sCustom_0').val()),
                    { name: 'sCustom_1', value: appn.taskTemplateFilter.getStateOrDefault().value },
                    appn.dataTable.getStateOrDefault('sCustom_2', $('#sCustom_2').val()),
                    appn.dataTable.getStateOrDefault('sCustom_3', $('#timeZoneFilter').val()),
                    { name: 'sCustom_5', value: $('#ParentTaskId').val() },
                    { name: 'sCustom_6', value: appn.dateFilter.getStateOrDefaultAsString() },
                    { name: 'sCustom_7', value: $('#LocationFilter').val() });

                if (_initArgs.userGroupsList.length > 0)
                    data.push(appn.dataTable.getStateOrDefault('sCustom_4', $('#sCustom_4').val()));

                if (_isFirstLoad && _initArgs.isParameterized) {
                    // Clear out any search values and reset paging that was stored in cache since we are navigating from map page to index with specific filters
                    data = appn.dataTable.clearSearchData(data);
                    appn.dataTable.resetPaging();
                    _isFirstLoad = false;
                }
            },
            aaSorting: [[5, 'desc']],
            aoColumns: [
                { bSortable: false, sWidth: '3%' },
                { bSortable: true, sWidth: '30%' },
                { bSortable: true, sWidth: '20%' },
                { bSortable: true, sWidth: '20%' },
                { bSortable: true, sWidth: '13%' },
                { bSortable: true, sWidth: '13%' }
            ],
            fnInitComplete: function () {
                // Time Zone Dropdown
                $('.dataTables_filter').prepend(appn.elementBuilder.buildSelect(_initArgs.timeZonesList, 'timeZoneFilter', appn.emptyString, undefined, undefined, 'max-width:200px'));

                // User Group Dropdown
                if (_initArgs.userGroupsList.length > 0)
                    $('.dataTables_filter').prepend(appn.elementBuilder.buildSelect(_initArgs.userGroupsList, 'sCustom_4', 'saveMeState userGroupsFilter'));

                // Users Dropdown
                $('.dataTables_filter').prepend(appn.elementBuilder.buildAppnSelect(_initArgs.usersList, 'sCustom_2', 'saveMeState usersFilter select2-noinit'));

                // System Statuses Dropdown
                let statusSelectHtml = `<select style="margin-left: 0.5em;" id="sCustom_0" class="form-control-sm form-control saveMeState"><option value="">${T("ALL STATUSES")}</option><option value="AllIncomplete">${T("ALL INCOMPLETE")}</option>`;

                for (let i = 0; i < _initArgs.systemStatusesList.length; i++) {
                    let value = _initArgs.systemStatusesList[i].value;
                    let display = _initArgs.systemStatusesList[i].text;
                    let selected = value === _initArgs.statusFilter ? 'selected="selected"' : '';
                    statusSelectHtml += `<option value="${value}" ${selected}>${display}</option>`;
                }

                statusSelectHtml += '</select>';

                $('.dataTables_filter').prepend(statusSelectHtml);

                _systemStatuses = $('#sCustom_0 option:not([value=""]):not([value="AllIncomplete"])').clone();

                // Inject Screen Action buttons
                appn.actionButtons.renderNavbarActionButtons([
                    { buttonId: 'manageBtn', buttonType: 'Manage', isDataTableToggleBtn: true }
                ], appn.requestUser.isUserOrHigher, true);

                appn.actionButtons.renderNavbarActionButtons([
                    { buttonId: 'importBtn', buttonType: 'Import' },
                    { buttonId: 'addnew', buttonType: 'AddNew' }
                ], appn.requestUser.isUserOrHigher);

                $('#timeZoneFilter').off().on('change', function() {
                    _dataTable.fnDraw(false);
                });

                // Prepend the show button
                (appn as any).sideFilterAndContent.appendShowButton($('#DataTables_Table_0_filter'));

                if (_initArgs.modelHasTemplates)
                    $('#addnew').on('click', function(e: Event) {
                        e.preventDefault();
                        appn.tasks.showAddNewDialog();
                    });
                else
                    $('#addnew').on('click', function(e: Event) {
                        e.preventDefault();
                        appn.location.navTo(_initArgs.tasksCreate);
                    });

                $('#importBtn').on('click', function(e: Event) {
                    e.preventDefault();
                    $('#importDialog').modal('show');

                    return false;
                });

                // Bind manage tasks button
                $('#manageBtn').on('click', function(this: HTMLElement, e: Event) {
                    e.preventDefault();
                    if ($(this).css('opacity') === '1') {
                        // Set selectedItems
                        _selectedItems = $('.selectRow:checked');

                        let userIds = appn.emptyString;
                        $(_selectedItems).map(function() {
                            userIds += `${($(this).attr('id'))},`;
                        });

                        $('#tasksToManage').val(userIds);
                        $('#manageTasksDialog').modal('show');

                        const submitButton = $('#manageTasksDialog .card-header button[value="Manage_Trash"].btn-tool-danger');
                        submitButton.attr('data-trashdetail', createTrashMessageFromTable(submitButton, _selectedItems));
                    }
                });

                appn.dataTable.addSearchPlaceholder(T('Filter results where the Tasks <b>Name, Users Firstname, Users Lastname or Complete At Text</b> contains a keyword typed in here.'));

                getCustomStatuses(function() {
                    appn.saveMeState.init(function() {
                        _dataTable.fnDraw(false);
                    },
                    function() {
                        _dataTable.fnDraw(false);
                        }, '.dataTables_filter');

                    isTableInitComplete = true;
                    select.init();
                });

                appn.dialog.showBillUpgradeOnClick();
                select.init({ selector: '#sCustom_2', minimumResultsForSearch: '25' }) // Start displaying 'search' at 25 items
            },
            fnDrawCallback: function() {
                if (isTableInitComplete)
                    getCustomStatuses();
            }
        });
    }

    let isTableInitComplete = false; // Needed to avoid a race condition and prevent a double ajax to the server.

    function getCustomStatuses(callback?: Function): void {

        const templateId = appn.taskTemplateFilter.getStateOrDefault().value;

        if (!templateId) {

            reApplyDefaultStatuses();

            if (callback)
                callback();

            return;
        }

        // do we already have this templates statuses?
        if (_taskTemplateStatusesCache) {
            const templateItem = _taskTemplateStatusesCache[templateId];
            if (templateItem) {
                reArrangeStatuses(templateItem);

                if (callback)
                    callback();

                return;
            }
        }

        appn.ajax.get({
            url: appn.location.buildUrlWithQueryString(_initArgs.tasksAjaxGetMergedStatuses, [{ name: 'templateId', value: templateId }]),
            done: function(statuses: Array<TaskStatusObj>, textStatus: string, jqXHR: JQueryXHR) {

                // Be sure to set the cache so we dont have to call the server with filters other than the template filter are selected.
                _taskTemplateStatusesCache[templateId] = statuses;

                // Update the list
                reArrangeStatuses(statuses);

                if (callback)
                    callback();
            },
            fail: function() {
                appn.toast.notify(toast.Type.error, T('Failed to update custom statuses.'));
            }
        });
    }

    function reApplyDefaultStatuses() {
        const statusFilter = $('#sCustom_0');
        const prevSelectedValue = statusFilter.val() as string;

        // Remove all statuses apart from the blank and AllIncomplete
        $('#sCustom_0 option:not([value=""]):not([value="AllIncomplete"])').remove();

        statusFilter.append(_systemStatuses);
        statusFilter.val(prevSelectedValue);
    }

    function reArrangeStatuses(statuses: Array<TaskStatusObj>) {
         
        if (!statuses)
            return;

        let statusOptions = appn.emptyString;
        for (let i = 0; i < statuses.length; i++)
            statusOptions += `<option value="${statuses[i].Value}">${statuses[i].Display}</option>`;

        const statusFilter = $('#sCustom_0');
        const prevSelectedValue = statusFilter.val() as string;

        // Remove all statuses apart from the blank and AllIncomplete
        $('#sCustom_0 option:not([value=""]):not([value="AllIncomplete"])').remove();

        statusFilter.append(statusOptions);
        statusFilter.val(prevSelectedValue);
    }

    function createTrashMessageFromTable(button: JQuery<HTMLElement>, selectedRows: any): string {
        let msg: string;
        button.attr('data-trashdetail', emptyString);

        if (selectedRows.length > 1) { // If we have multiple items
            const ul = elementBuilder.createElement('ul', (selectedRows.length > 5 ? 'scroller' : undefined));
            selectedRows.each(function(index: number, selected: JQuery<HTMLElement>) {
                const name = $($(selected).closest('tr').find('td')[3]).text();
                const desc = $($(selected).closest('tr').find('td')[1]).clone()
                    .find('.dt-titleText')
                    .text()
                    .trim();

                const item = T('<b>{0}</b> assigned to <b>{1}</b>', desc, name);
                const li = elementBuilder.createElement('li', undefined, undefined, undefined, item);

                ul.appendChild(li);
            });

            msg = T('The following <b>Tasks</b> will be moved to Trash and will no longer be available for use.') + ul.outerHTML;
        } else { // if we have a single item
            const name = $($(selectedRows[0]).closest('tr').find('td')[3]).text();
            const desc = $($(selectedRows[0]).closest('tr').find('td')[1]).clone()
                .find('.dt-titleText')
                .text()
                .trim();

            msg = T('Task <b>{0}</b> assigned to <b>{1}</b> will be moved to Trash and will no longer be available for use.', desc, name);
        }

        const p = elementBuilder.createElement('p', undefined, undefined, undefined, msg);

        return JSON.stringify(p.outerHTML);
    }

    export interface TaskStatusObj {
        Value: string;
        Display: string;
        Color: string;
    }
}
